import React from 'react'
import { Pie } from 'react-chartjs-2'
import filesize from 'filesize'
import { Card, CardBody, Col, Row } from 'reactstrap'
import ServiceKeyValueCard from './ServiceKeyValueCard'
import { TServiceDetail } from '../../types/serviceView'

type TProps = {
    service: TServiceDetail
}

const ServiceVeeamPanel: React.FC<TProps> = ({ service }) => {
    const details = service.additionalDetails || {}
    const storageQuota = Number(details.storageQuota) || 0
    const usedStorageQuota = Number(details.usedStorageQuota) || 0
    const freeStorageQuota = Math.max(storageQuota - usedStorageQuota, 0)

    const pieChart = {
        datasets: [
            {
                data: [usedStorageQuota, freeStorageQuota],
                backgroundColor: ['#FFC599', '#66E4FF'],
            },
        ],
        labels: ['Usage', 'Free'],
    }

    return (
        <Card className="service-detail-card shadow-sm border-0 mt-4">
            <CardBody>
                <Row className="align-items-start">
                    <Col lg={5} className="mb-4">
                        <ServiceKeyValueCard
                            title="Cloud Repository Storage"
                            items={[
                                {
                                    label: 'Usage',
                                    value: filesize(usedStorageQuota),
                                    tone: 'warning',
                                },
                                {
                                    label: 'Free',
                                    value: filesize(freeStorageQuota),
                                    tone: 'primary',
                                },
                                {
                                    label: 'Total Quota',
                                    value: filesize(storageQuota),
                                },
                                {
                                    label: 'Number of VMs in Cloud Repository',
                                    value: details.vms ?? '--',
                                },
                                {
                                    label: 'Rental Period',
                                    value:
                                        details.rentalPeriod !== undefined
                                            ? `${details.rentalPeriod} months`
                                            : '--',
                                },
                            ]}
                        />
                    </Col>
                    <Col lg={7} className="mb-4">
                        <div
                            className="service-detail-chart service-detail-chart--pie"
                            style={{ minHeight: '320px' }}
                        >
                            <Pie
                                data={pieChart}
                                options={{
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: true,
                                        position: 'bottom',
                                    },
                                    tooltips: {
                                        callbacks: {
                                            label(tooltipItems, data) {
                                                const label =
                                                    data.labels?.[
                                                        tooltipItems.index
                                                    ] || ''
                                                return `${label}: ${filesize(
                                                    data.datasets[
                                                        tooltipItems.datasetIndex
                                                    ].data[tooltipItems.index]
                                                )}`
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end">
                    <a
                        className="btn btn-secondary text-white"
                        href="https://vac.hso-group.net:1280/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Veeam Portal
                    </a>
                </div>
            </CardBody>
        </Card>
    )
}

export default ServiceVeeamPanel
